class rStarRating {
    constructor(starsHolder) {
        if (!starsHolder) {
            return;
        }

        this.starsHolder = starsHolder;
        this.fullStarsEl = this.starsHolder.querySelector(".js-star-rating-full");
        this.ratingInputElements = this.starsHolder.querySelectorAll('input[name="rating"]');

        for (const inputEl of this.ratingInputElements) {
            for (const inputLabelEl of inputEl.labels) {
                inputLabelEl.addEventListener("mouseenter", this.onMouseEnter.bind(this));
                inputLabelEl.addEventListener("mouseleave", this.onMouseLeave.bind(this));
            }

            inputEl.addEventListener("change", this.onChange.bind(this));
        }
    }

    get currentRatingValue() {
        return this.starsHolder.querySelector('input[name="rating"]:checked').value;
    }

    setStars(rating) {
        this.fullStarsEl.dataset.rating = rating;
    }

    onMouseEnter(event) {
        this.setStars(event.target.control.value);
    }

    onMouseLeave() {
        this.setStars(this.currentRatingValue);
    }

    onChange() {
        this.setStars(this.currentRatingValue);
    }
}

const rStarRatingElements = document.querySelectorAll(".js-star-rating-interactive");
rStarRatingElements.forEach((element) => new rStarRating(element));
